import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {STRATEGY_NEW_RULES} from 'smag-commons/dto/eco/community';
import {STRATEGY_OLD_CONDO} from 'smag-commons/dto/eco';
import {FormBuilder} from '@angular/forms';
import {MsgBoxService} from '../../../../shared/msg-box.service';
import {I18NService} from '../../../../i18n/i18n.service';
import {SmagApiService} from '../../../../api/smag-api.service';


export interface SelectedStrategy {
    type: string;
}


@Component({
    selector: 'app-strategy',
    templateUrl: './strategy.component.html',
    styleUrls: ['./strategy.component.scss']
})
export class StrategyComponent implements OnInit, OnDestroy {

    private destroyed = new Subject<void>();
    readonly STRATEGY_NEW_RULES = STRATEGY_NEW_RULES;
    readonly STRATEGY_OLD_CONDO = STRATEGY_OLD_CONDO;
    @Input() availableStrategies: string[];
    @Output() selected: EventEmitter<SelectedStrategy> = new EventEmitter<SelectedStrategy>();


    constructor(private readonly fb: FormBuilder,
                private readonly msgBoxService: MsgBoxService,
                private readonly i18n: I18NService,
                private readonly apiService: SmagApiService) {
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    onClickCancel() {
        this.selected.emit(null);
    }

    onSelectStrategy(strategy: string) {
        const selected = {
            type: strategy,
        } as SelectedStrategy;
        this.selected.emit(selected);
    }


}
